import { Component } from '@angular/core';

@Component({
  selector: 'app-forgot',
  standalone: false,
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.css'
})
export class ForgotComponent {

}
